import { render, staticRenderFns } from "./SearchCard.vue?vue&type=template&id=56b6f007&scoped=true&"
import script from "./SearchCard.vue?vue&type=script&lang=ts&"
export * from "./SearchCard.vue?vue&type=script&lang=ts&"
import style0 from "./SearchCard.vue?vue&type=style&index=0&id=56b6f007&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b6f007",
  null
  
)

export default component.exports